import styled from 'styled-components'

export const P = styled.p`
  position: relative;
  width: 6.25em;
  height: 1.875em;
  left: 70%;
  bottom: 2.5em;
  background-color: white;
  font-size: 0.75em;
  margin: 0;
  z-index: 1000;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 10px;
  -webkit-box-shadow: 0px 0.125em 0.313em 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0.125em 0.313em 0px rgba(0, 0, 0, 0.75);
  border: 0.063em solid rgba(192, 192, 192, 0.5);
  color: ${props => props.theme};
  cursor: pointer;
  &:active {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
`

export const Div = styled.div`
  width: 100%;
  height: 15.625em;
  margin: auto;
  margin-bottom: 0.625em;
`



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/styles/SmallMap.js